/** Web stub: satisfies @solana/wallet-adapter-react imports without react-native. */

export const SolanaMobileWalletAdapterWalletName = "Mobile Wallet Adapter";
export const SolanaMobileWalletAdapterRemoteWalletName = "Remote Mobile Wallet Adapter";

export class SolanaMobileWalletAdapter {
  constructor() {
    this.name = SolanaMobileWalletAdapterWalletName;
  }

  async connect() {}
  async disconnect() {}
}

export function createDefaultAddressSelector() {
  return {
    select: async (addresses) => addresses[0],
  };
}

export function createDefaultAuthorizationResultCache() {
  return {
    clear: async () => {},
    get: async () => undefined,
    set: async () => {},
  };
}

export function createDefaultWalletNotFoundHandler() {
  return async () => {};
}
